import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '@redux/hooks';
import { canAccessKontrolAlerts } from '@shared/navigation/helpers/canAccessKontrolAlerts';

interface KontrolAlertsRouteProps {
    children: React.ReactNode;
}

/**
 * Guards /kontrol/alerts: same rules as the Alerts Side Menu entry
 * ({@link canAccessKontrolAlerts}).
 */
export function KontrolAlertsRoute({ children }: KontrolAlertsRouteProps) {
    const navigate = useNavigate();
    const { TenantType: tenantType } = useAppSelector((state) => state.userProfile);
    const { tenantId, partnerId, tenantName, partnerName } = useAppSelector(
        (state) => state.selection
    );

    const allowed = useMemo(
        () =>
            canAccessKontrolAlerts(tenantType, {
                tenantId,
                partnerId,
                tenantName,
                partnerName,
            }),
        [tenantType, tenantId, partnerId, tenantName, partnerName]
    );

    const isProfilePending = !tenantType || tenantType === '';

    useEffect(() => {
        if (isProfilePending) return;
        if (!allowed) {
            navigate('/kontrol', { replace: true });
        }
    }, [isProfilePending, allowed, navigate]);

    if (isProfilePending) {
        return (
            <div className="flex min-h-[240px] flex-1 items-center justify-center text-sm text-semantic-text-secondary">
                Loading...
            </div>
        );
    }

    if (!allowed) {
        return null;
    }

    return <>{children}</>;
}
